var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',[_c('UserForm',{attrs:{"userId":_vm.userId,"edit-mode":true}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }